module.exports = __webpack_public_path__ + "img/remove-circled.1b6dc5f0.svg";